import { useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

export function EvalQueueNavigation({
  canGoBack,
  canGoForward,
  isBusy,
  onPrevious,
  onNext,
}: {
  canGoBack: boolean
  canGoForward: boolean
  isBusy: boolean
  onPrevious: () => void
  onNext: () => void
}) {
  const { t } = useLingui()
  return (
    <Box display='flex' gap='sm' shrink={false}>
      <Button
        type='button'
        variant='inputRaised'
        size='icon-lg'
        disabled={isBusy || !canGoBack}
        aria-label={t`Previous page in queue`}
        onClick={onPrevious}>
        <ChevronLeft />
      </Button>
      <Button
        type='button'
        variant='inputRaised'
        size='icon-lg'
        disabled={isBusy || !canGoForward}
        aria-label={t`Next page in queue`}
        onClick={onNext}>
        <ChevronRight />
      </Button>
    </Box>
  )
}
